/**
 * Guest Prefix Type
 */
export const Prefix = [
  {
    value: 'MR',
    title: 'Mr.'
  },
  {
    value: 'MRS',
    title: 'Mrs.'
  },
  {
    value: 'MS',
    title: 'Ms.'
  },
  {
    value: 'MISS',
    title: 'Miss'
  },
  {
    value: 'DR',
    title: 'Dr.'
  },
  {
    value: 'JUDGE',
    title: 'Judge'
  },
];

export const PrefixToLabel = {
  MR: 'Mr.',
  MRS: 'Mrs.',
  MS: 'Ms.',
  MISS: 'Miss',
  DR: 'Dr.',
  JUDGE: 'Judge'
};

/**
 * RSVP Type
 */
export const RsvpType = [
  {
    title: 'No Response',
    value: 'NO_RESPONSE'
  },
  {
    title: 'Attending',
    value: 'ATTENDING'
  },
  {
    title: 'Declined',
    value: 'DECLINED'
  }
];

export const RsvpToLabel = {
  NO_RESPONSE: 'No Response',
  ATTENDING: 'Attending',
  DECLINED: 'Declined'
};



/** WEBPACK FOOTER **
 ** ./src/components/manage/guestlist/GuestListTypes.js
 **/